import ChurchIcon from "../../assets/logos/Oikos Church Icon.png";

export default function PanelLoadingState({
  title = "Loading",
  detail = "Preparing this page...",
  iconAlt = "",
  iconComponent: IconComponent = null,
  iconSrc = "",
}) {
  const loaderIcon = iconSrc || ChurchIcon;

  return (
    <div style={styles.panel} role="status" aria-label={title}>
      <div style={styles.content}>
        <div style={styles.iconStage}>
          <span style={{ ...styles.sheet, ...styles.sheetBack }} />
          <span style={{ ...styles.sheet, ...styles.sheetMid }} />
          <span style={styles.iconHalo} />
          <span style={styles.iconGlass}>
            {IconComponent ? (
              <IconComponent aria-hidden="true" size={44} strokeWidth={2.35} style={styles.vectorIcon} />
            ) : (
              <img src={loaderIcon} alt={iconAlt || "Oikos Church icon"} style={styles.icon} />
            )}
          </span>
        </div>
        <div style={styles.title}>{title}</div>
        <div style={styles.detail}>{detail}</div>
        <div style={styles.loaderRow} aria-hidden="true">
          {[0, 1, 2].map((index) => (
            <span
              key={index}
              style={{
                ...styles.ball,
                animationDelay: `${index * 0.18}s`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  panel: {
    alignItems: "center",
    boxSizing: "border-box",
    display: "grid",
    justifyItems: "center",
    minHeight: "calc(100dvh - 132px)",
    padding: "48px 20px",
    placeItems: "center",
    width: "100%",
  },
  content: {
    textAlign: "center",
  },
  iconStage: {
    height: 126,
    margin: "0 auto 14px",
    position: "relative",
    width: 126,
  },
  sheet: {
    background: "rgba(255,255,255,0.62)",
    border: "1px solid rgba(190,202,232,0.7)",
    borderRadius: 8,
    boxShadow: "0 18px 42px rgba(23,32,51,0.12)",
    height: 74,
    left: 27,
    position: "absolute",
    top: 27,
    width: 72,
  },
  sheetBack: {
    animation: "pages-loading-sheet-back 2.8s ease-in-out infinite",
    transform: "rotate(-10deg) translate(-13px, 10px)",
  },
  sheetMid: {
    animation: "pages-loading-sheet-mid 2.8s ease-in-out infinite",
    transform: "rotate(8deg) translate(13px, 7px)",
  },
  iconHalo: {
    animation: "pages-loading-pulse 1.8s ease-in-out infinite",
    background: "rgba(var(--color-primary-rgb), 0.16)",
    borderRadius: "50%",
    inset: 14,
    position: "absolute",
  },
  iconGlass: {
    alignItems: "center",
    animation: "pages-loading-float 2.2s ease-in-out infinite",
    backdropFilter: "blur(18px) saturate(1.2)",
    WebkitBackdropFilter: "blur(18px) saturate(1.2)",
    background: "rgba(255,255,255,0.82)",
    border: "1px solid rgba(255,255,255,0.82)",
    borderRadius: 8,
    boxShadow: "0 20px 42px rgba(var(--color-primary-rgb), 0.18), inset 0 1px 0 rgba(255,255,255,0.72)",
    display: "flex",
    height: 70,
    justifyContent: "center",
    left: 28,
    position: "absolute",
    top: 28,
    width: 70,
  },
  icon: {
    display: "block",
    height: 54,
    objectFit: "contain",
    width: 54,
  },
  vectorIcon: {
    color: "var(--color-primary)",
    display: "block",
  },
  loaderRow: {
    alignItems: "center",
    display: "flex",
    gap: 10,
    justifyContent: "center",
    marginTop: 18,
  },
  ball: {
    animationDuration: "0.9s",
    animationIterationCount: "infinite",
    animationName: "oikos-loading-bounce",
    animationTimingFunction: "ease-in-out",
    background: "var(--color-primary)",
    borderRadius: 999,
    height: 12,
    width: 12,
  },
  title: {
    color: "#0f172a",
    fontSize: 18,
    fontWeight: 850,
    marginBottom: 6,
  },
  detail: {
    color: "#64748b",
    fontSize: 14,
    lineHeight: 1.45,
  },
};
